export default "__VITE_ASSET__CdtyOZs___"